// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"MessageModal_backdrop__2BBA_","modal":"MessageModal_modal__1OW82","slide-down":"MessageModal_slide-down__1BQqA","content":"MessageModal_content__3R_uz"};